import(/* webpackMode: "eager", webpackExports: ["HeroCarousel"] */ "/vercel/path0/components/home-hero-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomepageHoverCards"] */ "/vercel/path0/components/homepage-hover-cards.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/reusable-carousel-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeBlogSection"] */ "/vercel/path0/components/sections/home-blog-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_babel-plugin-react-compiler@19.0.0-beta-27714ef-20250124_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_babel-plugin-react-compiler@19.0.0-beta-27714ef-20250124_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
